const linkToStore = document.querySelector(".some-login-btn");

document.addEventListener("DOMContentLoaded", (e) => {
    const cartItems = document.querySelectorAll(".cartItemInfo");
    const productCartIcons = document.querySelectorAll(".product_cart_icon");
    const cartItemsObj = {};

    cartItems.forEach((elem) => {
        cartItemsObj[`${elem.dataset.id}`] = elem.dataset.qty;
    });

    //Removed 09 Jan 25 on Sonae request
    // productCartIcons.forEach((elem) => {
    //     const productId = elem.dataset.productid;
    //     const productQty = cartItemsObj[productId];

    //     if (productQty) {
    //         const cartQtyIcon = elem.querySelector(".product_cart_icon-qty");
    //         cartQtyIcon.style.display = "flex";
    //         cartQtyIcon.textContent = productQty;
    //     }
    // });
});

linkToStore?.addEventListener("click", async function (e) {
    e.preventDefault();

    const customerEmail = document.querySelector("#customer-email");
    const customerFirstname = document.querySelector("#customer-first-name");
    const customerLastname = document.querySelector("#customer-last-name");

    if (customerEmail && customerEmail.value) {
        
        const customer_data = {
            email: customerEmail.value.trim(),
            first_name: customerFirstname?.value?.trim() || "",
            last_name: customerLastname?.value?.trim() || "",
        };

        // const tokenRes = await fetch('https://sonae-shopify-app.stg.theloop.tech/composetoken?redirectTo=bazaar-test-lab', {
        //     method: "POST",
        //     body: JSON.stringify({data: customer_data}),
        //     headers: {
        //         "Content-Type": "application/json"
        //     }
        // }).then((res) => res.json());

        // if (tokenRes){
        //     location.assign(`https://bazaar-test-lab.myshopify.com/account/login/multipass/${tokenRes.data.token}`);
        // }

    }

})


